jQuery(document).on('ready', () => {
    CONTACT.bp = 768;
    CONTACT.onReady();
    CONTACT.onResize();
});

var CONTACT = {
    onReady: () => {

        if ( jQuery('#form-contact').length < 1 )
            return;

        
        jQuery('#form-contact .control.countries').hide();
        jQuery('#form-contact .control.participants input').prop('checked', false);
        jQuery('#form-contact .control.countries select[name=country] option:selected').prop('selected', false);

        jQuery('#form-contact input[name=participant]').on('change', CONTACT.changeParticipant );
        jQuery('#form-contact select[name=country]').on('change', CONTACT.changeCountry );
    },



    onResize: () => {
        jQuery(window).on('resize orientationChange', () => {
            // BASE.placeLangNav();
            
        });
    },



    changeParticipant: () => {
        CONTACT.participant = jQuery('#form-contact input[name=participant]:checked').val();

        jQuery('#form-contact .results').hide();
        jQuery('#form-contact .control.countries').hide();
        jQuery('#form-contact .control.countries select[name=country] option:selected').prop('selected', false);

        jQuery('#form-contact select[name=country]').parent().toggleClass('is-loading');
        jQuery('#form-contact .control.countries.' + CONTACT.participant).fadeIn();
        jQuery('#form-contact select[name=country]').parent().toggleClass('is-loading');
    },



    changeCountry: () => {
        CONTACT.country = jQuery('#form-contact .countries.' + CONTACT.participant + ' select[name=country] option:selected').val();

        CONTACT.showContact();

        TRACKING.sendGA4event(
                            jQuery('#form-contact').data('action'), 
                            {
                                'contact_type'  : jQuery('#form-contact').data('action'),
                                'issuer'        : CONTACT.participant,
                                'country'       : CONTACT.country,
                                'language'      : snJS.lang 
                            }
                        );
    },
        
      

    showContact: () => {
        jQuery('#form-contact .results').hide();
        jQuery('#form-contact .results.' + CONTACT.participant + '.' + CONTACT.country).fadeIn();
    }  
};
